import { getAssetDownloadFilename } from '#pplx/frontend/apps/ask/canvas-shared/useAssetInfo.js';
const COMPUTER_ASSET_DOCUMENT_TITLE_FALLBACK = 'Perplexity Computer';
function firstNonEmptyString(...values) {
    return values.map((value) => value?.trim()).find(Boolean) ?? null;
}
export function getComputerAssetDocumentTitle(asset) {
    if (!asset) {
        return COMPUTER_ASSET_DOCUMENT_TITLE_FALLBACK;
    }
    return (firstNonEmptyString(asset.app?.name, asset.chart?.name, asset.code_file?.name, asset.code_file?.filename, asset.pdf_file?.name, asset.docx_file?.name, asset.doc_file?.name, asset.xlsx_file?.name, asset.slide_file?.name, asset.audio_file?.name, asset.audio_file?.filename, asset.model_3d?.name, asset.model_3d?.filename, asset.research_report?.name, asset.quiz?.title, asset.flashcards?.title, getAssetDownloadFilename(asset)) ?? COMPUTER_ASSET_DOCUMENT_TITLE_FALLBACK);
}
//# sourceMappingURL=computerAssetDocumentTitle.js.map